import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Todos de qualquer segmento",
    correct: false,
  },
  {
    option: "b) Grandes e médios de qualquer segmento",
    correct: false,
  },
  {
    option: "c) Pequenos do mundo de telecomunicação",
    correct: false,
  },
  {
    option: "d) Situações especiais de dados em bancos",
    correct: false,
  },
  {
    option: "e) Grandes volumes em telecomunicações, utilities e bancos",
    correct: true,
  },
];

export default function Question28(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question28: {
          title:
            "DORA deveria ser ofertado para clientes de qual segmento e dimensão?",
          option: option.option,
          correct: option.correct,
          order: 28
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "DORA deveria ser ofertado para clientes de qual segmento e dimensão?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
